import { RoomSyncSettingsForm } from "./RoomSyncSettingsForm";
import { useMemo, useState } from "react";
import { Button, Card, Modal, Stack, Text, Title } from "@mantine/core";
import { FaHistory } from "react-icons/fa";
import { useAppSelector } from "../app/hooks";
import { useProjectId } from "../hooks/useProjectId";
import { ProjectSyncRunsPanel } from "../RoomTab/ProjectSyncRunsPanel";
import { ProjectSyncStartButton } from "../RoomTab/ProjectSyncStartButton";
import { useGetAuthMeQuery, useGetMultiplacerProjectsSingleProjectQuery } from "../../openapi";
import { makeSelectRoomSyncAccess } from "./roomSyncSettingsSelectors";

export function RoomSyncSettingsCard() {
  const projectNo = useProjectId();
  const [historyOpen, setHistoryOpen] = useState(false);
  const hasProject = Number.isFinite(projectNo) && projectNo > 0;

  const { isLoading, isError } = useGetMultiplacerProjectsSingleProjectQuery(
    { projectNo },
    { skip: !hasProject, refetchOnMountOrArgChange: true }
  );
  useGetAuthMeQuery();
  const selectAccess = useMemo(() => makeSelectRoomSyncAccess(projectNo), [projectNo]);
  const { owners, canStart } = useAppSelector(selectAccess);

  return (
    <Card withBorder radius="lg" p="lg">
      <Stack gap="md">
        <Title order={4}>Romsynk</Title>
        <Text size="sm" c="dimmed">
          Synkroniser og berik prosjektets romdata, og se status og historikk for kjøringene.
        </Text>
        <Text size="sm">
          Kun prosjekteiere kan starte romsynk. Du kan se tidligere kjøringer nedenfor.
        </Text>
        <Stack gap={4}>
          <Text size="sm" fw={600}>
            Prosjekteiere
          </Text>
          {isLoading ? (
            <Text size="sm" c="dimmed">
              Laster prosjekteiere…
            </Text>
          ) : isError ? (
            <Text size="sm" c="red">
              Kunne ikke hente prosjekteiere. Last siden på nytt.
            </Text>
          ) : owners.length === 0 ? (
            <Text size="sm" c="dimmed">
              Ingen prosjekteiere er registrert.
            </Text>
          ) : (
            owners.map((owner) => (
              <Text size="sm" key={String(owner.userId)}>
                {owner.displayName || owner.email || "Ukjent navn"}
                {owner.displayName && owner.email ? ` (${owner.email})` : ""}
              </Text>
            ))
          )}
        </Stack>
        {hasProject && !isLoading && !isError && (
          <RoomSyncSettingsForm projectNo={projectNo} canEdit={canStart} />
        )}
        {hasProject && canStart && <ProjectSyncStartButton projectNo={projectNo} />}
        <Button
          size="xs"
          variant="light"
          leftSection={<FaHistory size={14} />}
          onClick={() => setHistoryOpen(true)}
          disabled={!hasProject}
          style={{ alignSelf: "flex-start" }}
        >
          Synkroniseringshistorikk
        </Button>
      </Stack>
      <Modal
        opened={historyOpen}
        onClose={() => setHistoryOpen(false)}
        title="Historikk for romsynk"
        size="lg"
        centered
      >
        {historyOpen && hasProject && <ProjectSyncRunsPanel projectNo={projectNo} />}
      </Modal>
    </Card>
  );
}
